"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderRender = void 0;
var React = __importStar(require("react"));
var Menu_1 = __importDefault(require("semantic-ui-react/dist/commonjs/collections/Menu"));
var ResponsiveMenu_1 = __importDefault(require("./ResponsiveMenu/ResponsiveMenu"));
var ResponsiveHelper_1 = __importDefault(require("../ResponsiveHelper/ResponsiveHelper"));
var react_1 = require("react");
var localization_1 = require("@scuf/localization");
var Item_1 = __importDefault(require("./Item/Item"));
var Icon_1 = __importDefault(require("../Icon/Icon"));
var Search_1 = __importDefault(require("./Search/Search"));
var UserProfile_1 = __importDefault(require("./UserProfile/UserProfile"));
var HeaderRender = /** @class */ (function (_super) {
    __extends(HeaderRender, _super);
    function HeaderRender(props) {
        var _this = _super.call(this, props) || this;
        _this.genTitle = function () {
            var _a = _this.props, title = _a.title, onTitleClick = _a.onTitleClick;
            var titleContent = React.createElement("span", { className: "logo-text" }, title);
            if (onTitleClick) {
                return (React.createElement("div", { className: "logo-text-link", onClick: onTitleClick }, titleContent));
            }
            return titleContent;
        };
        _this.genLogo = function () {
            var onLogoClick = _this.props.onLogoClick;
            if (onLogoClick) {
                return (React.createElement("div", { className: "logo-link", onClick: onLogoClick }, _this.genLogoContent()));
            }
            return _this.genLogoContent();
        };
        _this.genLogoContent = function () {
            var _a = _this.props, logo = _a.logo, logoUrl = _a.logoUrl, isForge = _a.isForge;
            if (isForge) {
                return React.createElement("div", { className: "ui forge-logo" }, "HONEYWELL FORGE");
            }
            if (logo) {
                if (logoUrl) {
                    return React.createElement("div", { className: "ui main-logo", style: { backgroundImage: "url(" + logoUrl + ")" } });
                }
                return React.createElement("div", { className: "ui main-logo honeywell-logo" });
            }
            return null;
        };
        _this.onWidthChanges = function (width) {
            if (_this.props.responsive) {
                if (_this.props.collapseAt) {
                    _this.pxWidthChecks(width);
                }
                else if (!_this.props.collapseAtBreakpoint && !_this.state.compressed) {
                    _this.autoDetect();
                }
            }
        };
        _this.renderDrop = function () {
            var hasItems = react_1.Children.toArray(_this.props.children).filter(function (child) { return typeof child === 'object' && child.type !== Search_1.default; }).length;
            if (_this.state.collapsed && hasItems && _this.props.responsive) {
                var profileItem = react_1.Children.toArray(_this.props.children).find(function (child) { return typeof child === 'object' && child.type === UserProfile_1.default; });
                var cleanedItems = react_1.Children.toArray(_this.props.children).filter(function (child) { return typeof child === 'object' && child.type !== UserProfile_1.default; });
                if (profileItem) {
                    return React.createElement(ResponsiveMenu_1.default, { navItems: cleanedItems, profile: profileItem });
                }
                else {
                    return React.createElement(ResponsiveMenu_1.default, { navItems: cleanedItems });
                }
            }
            else {
                return null;
            }
        };
        _this.pxWidthChecks = function (width) {
            if (width < _this.props.collapseAt && !_this.state.collapsed) {
                _this.setState({ collapsed: true });
                _this.onHeaderTransition();
            }
            else if (width > _this.props.collapseAt && _this.state.collapsed) {
                _this.setState({ collapsed: false });
                _this.onHeaderTransition();
            }
        };
        _this.breakpointsWidthCheck = function (points) {
            if (_this.props.responsive && _this.props.collapseAtBreakpoint) {
                if (!points[_this.props.collapseAtBreakpoint] && !_this.state.collapsed) {
                    _this.setState({ collapsed: true });
                    _this.onHeaderTransition();
                }
                else if (points[_this.props.collapseAtBreakpoint] && _this.state.collapsed) {
                    _this.setState({ collapsed: false });
                    _this.onHeaderTransition();
                }
            }
            if (_this.props.responsive) {
                if (!points.xs && !_this.state.compressed) {
                    _this.setState({ collapsed: true, compressed: true });
                    _this.onHeaderTransition();
                }
                else if (points.xs && _this.state.compressed) {
                    _this.setState({ compressed: false });
                    _this.onHeaderTransition();
                }
            }
        };
        _this.onMenuToggle = function () {
            if (_this.props.onMenuToggle) {
                _this.props.onMenuToggle();
            }
        };
        _this.onHeaderTransition = function () {
            if (_this.props.onHeaderTransition) {
                _this.props.onHeaderTransition({ collapsed: _this.state.collapsed, compressed: _this.state.compressed });
            }
        };
        _this.state = {
            collapsed: false,
            compressed: false,
        };
        return _this;
    }
    HeaderRender.prototype.render = function () {
        var _this = this;
        var _a = this.props, logoUrl = _a.logoUrl, title = _a.title, logo = _a.logo, responsive = _a.responsive, className = _a.className, collapseAt = _a.collapseAt, collapseAtBreakpoint = _a.collapseAtBreakpoint, menu = _a.menu, onMenuToggle = _a.onMenuToggle, onHeaderTransition = _a.onHeaderTransition, t = _a.t, lng = _a.lng, isForge = _a.isForge, onLogoClick = _a.onLogoClick, onTitleClick = _a.onTitleClick, i18nToggleMenu = _a.i18nToggleMenu, rest = __rest(_a, ["logoUrl", "title", "logo", "responsive", "className", "collapseAt", "collapseAtBreakpoint", "menu", "onMenuToggle", "onHeaderTransition", "t", "lng", "isForge", "onLogoClick", "onTitleClick", "i18nToggleMenu"]);
        return (React.createElement("div", __assign({}, rest, { ref: function (ref) { return (_this.wrapRef = ref); }, className: this.genClasses() }),
            React.createElement(Menu_1.default, { className: "page-header-menu" },
                this.props.menu && (React.createElement(Item_1.default, { className: "menu-btn-item", onClick: this.onMenuToggle },
                    React.createElement("div", { className: "menu-btn" },
                        React.createElement(Icon_1.default, { root: "common", name: "menu", size: "small", description: i18nToggleMenu !== null && i18nToggleMenu !== void 0 ? i18nToggleMenu : t('Toggle Menu') })))),
                React.createElement(Item_1.default, { className: "logo-item" },
                    React.createElement("div", { className: "width-tester", ref: function (ref) { return (_this.logoRef = ref); } }),
                    this.genLogo(),
                    this.genTitle()),
                React.createElement(Menu_1.default.Menu, { position: "right", className: "page-header-menu" },
                    this.genItems(),
                    this.renderDrop()),
                responsive && !collapseAt && (React.createElement(Menu_1.default.Menu, { position: "right", className: "full-header-menu" },
                    React.createElement("div", { className: "width-tester", ref: function (ref) { return (_this.menuRef = ref); } }),
                    this.props.children))),
            React.createElement(ResponsiveHelper_1.default, { onChange: this.onWidthChanges, activeBreakPoints: this.breakpointsWidthCheck })));
    };
    HeaderRender.prototype.genClasses = function () {
        var classes = 'ui page-header';
        if (this.props.className) {
            classes += ' ' + this.props.className;
        }
        if (this.state.collapsed) {
            classes += ' is-collapsed';
        }
        if (this.props.menu) {
            classes += ' has-menu';
        }
        if (this.state.compressed) {
            classes += ' is-compressed';
        }
        return classes;
    };
    HeaderRender.prototype.genItems = function () {
        if (!this.state.collapsed || !this.props.responsive) {
            return this.props.children;
        }
        else {
            return null;
        }
    };
    HeaderRender.prototype.autoDetect = function () {
        var minSpaceBetweenItems = 25;
        var right = this.menuRef.getBoundingClientRect().width;
        var left = this.logoRef.getBoundingClientRect().width;
        var container = this.wrapRef.getBoundingClientRect().width;
        var gap = container - left - right - minSpaceBetweenItems;
        var menuBtnWidth = 72;
        if (this.props.menu) {
            gap = gap - menuBtnWidth;
        }
        if (gap <= 0) {
            this.setState({ collapsed: true });
            this.onHeaderTransition();
        }
        else {
            this.setState({ collapsed: false });
            this.onHeaderTransition();
        }
    };
    return HeaderRender;
}(react_1.Component));
exports.HeaderRender = HeaderRender;
exports.default = localization_1.InjectLocalization(HeaderRender);
